<!-- 发票列表 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <salesInvoiceActive ref="salesInvoiceActive"></salesInvoiceActive>

        <div class="page_content_top">
            <div class="page_content_top_line" style="display:flex;justify-content: space-between;">
                <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign">
                    <template slot="text">
                        <el-tag type="danger">总开票金额：{{ allPsmoney }}</el-tag>
                    </template>
                </v-button>
            </div>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :flagList="['dpstart', 'dpend', 'passEnd', 'passStart']" :getRequestData=getRequestData v-if="pageShowData.jurHead"
                         :searchList=pageShowData.jurHead.jurconfigform>
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-date-picker class="form_codition" @change="(val)=>{changeTime(formOneValue.entityField,val)}" v-if="formOneValue.fieldType == 'date'" v-model="getRequestData[formOneValue.entityField]"
                                        format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" :placeholder="'选择' + formOneValue.showField">
                        </el-date-picker>
                    </template>
                </vSearch>

            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe @sort-change="sortChange" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini" ref="mainTable" :show-summary="true"
                      :summary-method="getSummaries">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <!-- 主表单 -->
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                     :sortable="tableValye.isSort == 1 ? 'custom' : false">
                        <template slot-scope="scope">
                            <!-- 开票日期 -->
                            <template v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </template>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                            </span>
                            <div v-else-if="tableValye.entityField == 'pdfUrl'">
                                <ul v-if="scope.row[tableValye.entityField]">
                                    <li class="li_active" v-for="(val,index) in scope.row[tableValye.entityField].split(',')" :key="index" style="cursor: pointer;color: #333;" @click="toJump(val)">
                                        <span style="border-bottom: 1px solid #333;">{{ val }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else-if="tableValye.entityField == 'fileUrl' && scope.row.fileUrl" style="display: flex;flex-wrap: wrap;">
                                <cusImage v-for="(val, key) in scope.row.fileUrl.split(',')" :key="key" style="width: 30px; height: 30px;margin-top: 5px;margin-left: 5px;" :src="$common.getFileAddress(val)"
                                          :preview-src-list="[$common.getFileAddress(val)]">
                                </cusImage>
                            </div>
                            <div v-else-if="tableValye.fieldType == 'imgType'" style="display: flex;flex-wrap: wrap;">
                                <div v-if="scope.row[tableValye.entityField]">
                                    <cusImage v-for="(val,key) in scope.row[tableValye.entityField].split(',')" :key="key" style="width: 30px; height: 30px;margin-top: 5px;margin-left: 5px;" :src="$common.getFileAddress(val)"
                                        :preview-src-list="[$common.getFileAddress(val)]">
                                    </cusImage>
                                </div>
                                <span v-else></span>
                            </div>
                            <el-tag v-else-if="tableValye.entityField == 'dacmStatus'" size="mini">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.dacmStatus) }}</el-tag>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>

                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :cmId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="修改发票号" v-if="upInvoiceShow" :visible.sync="upInvoiceShow" width="600px">
            <div>
                <el-form @submit.native.prevent inline :model="upInvoiceData" class="demo-form-inline" size="mini">
                    <el-row>
                        <el-form-item label="旧发票号">
                            <label slot="label" :style="$common.labelStyle('旧发票号')" v-html="'旧发票号'"></label>
                            <el-input v-model="upInvoiceData.ticketNum" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="新发票号">
                            <label slot="label" :style="$common.labelStyle('新发票号')" v-html="'新发票号'"></label>
                            <el-input v-model="upInvoiceData.newticketNum" placeholder="请输入新发票号"></el-input>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="upInvoiceShow = false">取 消</el-button>
                <el-button type="primary" @click="confirmUp">确 定</el-button>
            </span>
        </el-dialog>
        <el-drawer id="drawer" :close-on-press-escape="true" :visible.sync="pdfUrlShow" title="下载发票" append-to-bodycustom-class="drawer_box" direction="rtl" size="100%">
            <div style="padding: 0 10px;">
                <iframe width="100%" :height="drawerHeight + 'px'" :src="pdfUrl" frameborder="0"></iframe>
            </div>
        </el-drawer>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog title="上传发票图片" :visible.sync="ticketNumFlag" width="400px">
            <el-form class="demo-form-inline" :model="formInline" label-width="75px" size="mini">
                <el-row>
                    <el-form-item label="发票号">
                        <el-input disabled style="width: 300px;" v-model="formInline.ticketNum" placeholder="发票号"></el-input>
                    </el-form-item>
                    <el-form-item label="轨号">
                        <el-input disabled style="width: 300px;" v-model="formInline.railNum" placeholder="轨号"></el-input>
                    </el-form-item>
                    <el-form-item label="上传发票">
                        <div>
                            <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                            <label for="recordExcel" class="image_label">上传发票</label>
                        </div>
                        <div>
                            <ul class="uploadList" v-if="formInline.fileUrl">
                                <li v-for="(val, key) in formInline.fileUrl.split(',')" :key="key" class="image">
                                    <i class="el-icon-error del" @click="delRemove(key)"></i>
                                    <el-image style="width: 40px; height: 40px;margin-top: 5px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                    </el-image>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                </el-row>
                <el-form-item>
                    <el-button type="primary" @click="fileUploadOnSub">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import salesInvoiceActive from '@/components/salesInvoiceActive.vue'

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        salesInvoiceActive
    },
    data() {
        //这里存放数据
        return {
            pdfUrlShow: false,
            drawerHeight: 500,
            pdfUrl: "",
            tableHeight: 0,
            getRequestData: {
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],

            formDataList: null,
            pageShowData: [],
            selectedDataIndex: 0,

            userOneList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            cmId: 0,
            sField: '',
            upInvoiceShow: false,
            upInvoiceData: {
                ticketNum: "",
                newticketNum: "",
            },
            totalField: [],
            requesUrl: '',
            imgUrl: '',
            ormId: '',
            allPsmoney: 0,
            parentSearchData: {},
            ticketNumFlag: false,//上传发票
            formInline: {
                railNum: "",
                ticketNum: "",
                fileUrl: "",
            },

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        changeTime(type, val) {
            if (type == 'passEnd') {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.passEnd = time;
            }
        },
        delRemove(key) {
            var list = []
            if (this.formInline.fileUrl) {
                list = this.formInline.fileUrl.split(',')
                list.splice(key, 1)
            }
            this.formInline.fileUrl = list.join()
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadimgUploadPath(params, true)
                console.log(response.result);
                if (response.status == 200) {
                    var list = []
                    if (this.formInline.fileUrl) {
                        list = this.formInline.fileUrl.split(',')
                        list.push(response.result)
                    } else {
                        list.push(response.result)
                    }
                    this.formInline.fileUrl = list.join()
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        async fileUploadOnSub() {
            if (this.formInline.fileUrl == "") {
                return this.$message.error("请上传发票图片")
            }
            const responseData = await this.$http.sudocumentsupFpimg(this.formInline)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: responseData.message
                });
                this.ticketNumFlag = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        toJump(url) {
            // this.pdfUrlShow = true
            // this.pdfUrl = url
            // this.$nextTick(() => {
            //     setTimeout(() => {
            //         var height = document.documentElement.querySelector("#drawer").clientHeight
            //         var topHeight = document.documentElement.querySelector("#drawer").querySelector(".el-drawer__header").clientHeight
            //         console.log(height, topHeight);
            //         this.drawerHeight = height - topHeight - 40
            //     }, 100)
            // })
            window.open(url, "_blank");
        },
        //  导出
        exportData() {
            window.location.href = this.requesUrl + '/sudocuments/exportSudocumentData?ormId=' + String(this.ormId) + '&cmName=' + this.getRequestData.cmName
                + '&cmId=' + this.getRequestData.cmId + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
                + '&coName=' + this.getRequestData.coName + '&coId=' + this.getRequestData.coId
                + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows
        },
        // 自定义合计字段
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            console.log(columns, data)
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.totalField.includes(column.property)) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.toDecimal(prev + curr);
                            } else {
                                return this.toDecimal(prev)
                            }
                        }, 0);
                        sums[index] = this.$common.getDecimalInfo(3, sums[index])
                        // sums[index] = sums[index].toFixed(2)
                        // sums[index] += ' 元';
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = ''
                }
            });

            return sums;
        },
        toDecimal(x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return;
            }
            f = Math.round(x * 100) / 100;
            return f;
        },
        confirmUp() {
            if (this.upInvoiceData.newticketNum == "") return this.$message({
                type: 'error',
                message: "请填写新发票号"
            })
            this.$confirm('保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.sudocumentSupdateFph(this.upInvoiceData).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: res.message,
                        })
                        this.getDataList()
                        this.upInvoiceShow = false
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message,
                        })
                    }
                })
            }).catch(() => { });
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.cmId = dataInfo.cmId
                        this.getRequestData.cmName = dataInfo.cmName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },
        //获取表头信息
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                // ids: [pathId.jurId],
                ids: [1613900963319] // 销售发票列表
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
                    if (item.fieldType == 'number') {
                        this.totalField.push(item.entityField)
                    }
                })
                this.formDataList = this.pageShowData.jurFormVoList
                this.formDataList[1].isShowForm = 1
                this.formDataList[2].isShowForm = 1
                this.formDataList[3].isShowForm = 1
                this.formDataList[4].isShowForm = 1
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData);
            switch (actionData.actionType) {
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: '暂无数据',
                                type: 'error'
                            });
                            return false
                        }
                    }
                    var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.$refs['salesInvoiceActive'].openBox(1, this.formDataList, dataInfo)
                    break;
                case 2:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: '暂无数据',
                                type: 'error'
                            });
                            return false
                        }
                    }
                    var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.upInvoiceData.ticketNum = dataInfo.ticketNum;
                    this.upInvoiceData.newticketNum = ""
                    this.upInvoiceShow = true
                    break;
                case 4:
                    this.exportData()
                    break;
                case 5:
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.$refs["processAuditAction"].openBox(1, dataInfo.ticketNum);
                    break;
                case 6: //发票作废
                    this.delDataAction()
                    break;
                case 7: //上传图片
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var fileUrl = ""
                    if (dataInfo.fileUrl) {
                        fileUrl = dataInfo.fileUrl
                    }
                    this.formInline = {
                        railNum: dataInfo.railNum,
                        ticketNum: dataInfo.ticketNum,
                        fileUrl: fileUrl
                    }
                    this.ticketNumFlag = true
                    break;
                case 8:
                    this.redPunch()
                    break;
            }
        },
        redPunch() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确认红冲此发票?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.ticketNum]
                }
                let responseData = await this.$http.sudocumentsRedRushBill(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '红冲成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                this.$refs.printPlan.openDia(info.woamId)
            } else {
                return
            }
        },
        // 发票作废
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确认作废此发票?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.ticketNum]
                }
                let responseData = await this.$http.sudocumentsZuoFei(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '作废成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });

        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.sudocumentsQueryHis(this.getRequestData)
            // console.log(responseData);
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.selectedDataIndex = 0
                this.getAllMoney()
                this.$nextTick(() => {
                    this.$refs.mainTable.doLayout()
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 获取销售开票总开票金额信息
        async getAllMoney() {
            let responseData = await this.$http.sudocumentsGetAllMoney(this.getRequestData)
            if (responseData && responseData.status == 200) {
                this.allPsmoney = responseData.result.allPsmoney
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },


        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.imgurl()
        this.ormId = sessionStorage.getItem('ormId')
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
        if (!this.$store.state.tableNum) {
            this.$store.state.tableNum = true
        } else {
            this.$store.state.tableNum = false
        }
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.li_active span:hover {
    color: blue;
    border-color: blue;
}
/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 45px;
    height: 45px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}
</style>